module.exports = "https://cdn-shared.mathletics.com/mathsaz/100/assets/images/dfe4a2a5a76ea77a764735c37880b77b.svg";